module.exports = __webpack_public_path__ + "static/media/template_indicadores_gerais_v2.be22c74a.csv";